import React from 'react';
import DatePicker from 'react-datepicker';
import { getMonth, getYear, addYears } from 'date-fns';
import range from 'lodash/range';

const CustomDatePicker = ({ onChange, selected, placeholderText, dateFormat, startDate, minDate, maxDate, isClearable }) => {

  const years = range(startDate || getYear(new Date()), getYear(addYears(new Date(), 10)) + 1, 1);
  const months = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];
  return (
    <DatePicker
      className='custom-date-picker'
      selected={selected}
      onChange={onChange}
      placeholderText={placeholderText}
      dateFormat={dateFormat}
      minDate={minDate ? minDate : ''}
      maxDate={maxDate ? maxDate : ''}
      isClearable={isClearable ? isClearable : ''}
    />
  );
};

export default CustomDatePicker;